import tagApi from '@/api/tag';

const SET_TAGS_TREE = 'SET_TAGS_TREE';
const SET_READ_TAGS_TREE = 'SET_READ_TAGS_TREE';
const MERGE_TAGS_TREE_STATE = 'MERGE_TAGS_TREE_STATE';

const state = {
  tree: [],
  readTree: [],
  // Merged state of the tree (checked, expanded ...) with api data
  treeState: []
};

const getters = {
  getTagsTree: state => {
    return state.tree;
  },
  getReadTagsTree: state => {
    return state.readTree;
  },
  getTagsTreeState: state => {
    return state.treeState;
  }
};

const mutations = {
  [SET_TAGS_TREE] (state, tree) {
    state.tree = tree;
    state.treeState = tree;
  },
  [SET_READ_TAGS_TREE] (state, readTree) {
    state.readTree = readTree;
  },
  [MERGE_TAGS_TREE_STATE] (state, { tree, prevTree }) {
    state.treeState = merge(prevTree, tree);
  }
};

const actions = {
  retrieveTagsTree ({ commit }, { context }) {
    tagApi.getTree(context).then(data => {
      commit(SET_TAGS_TREE, data);
    });
  },
  retrieveReadTagsTree ({ commit }, { context }) {
    tagApi.getReadTree(context).then(data => {
      commit(SET_READ_TAGS_TREE, data);
    });
  },
  updateTagsTree ({ commit }, { context, tree }) {
    return new Promise((resolve) => {
      tagApi.updateTree(context, tree).then(data => {
        commit(SET_TAGS_TREE, data);
        commit(MERGE_TAGS_TREE_STATE, { tree: data, prevTree: tree });
        resolve();
      });
    });
  },
  deleteTagNodes ({ commit }, { context, nodes, prevTree }) {
    return new Promise((resolve) => {
      tagApi.deleteNodes(context, nodes).then(data => {
        commit(SET_TAGS_TREE, data);
        commit(MERGE_TAGS_TREE_STATE, {tree: data, prevTree: prevTree});
        resolve();
      });
    });
  },
  removeTags ({ commit }, { context, variableIds, tagIds }) {
    return new Promise((resolve) => {
      tagApi.removeTags(context, variableIds, tagIds).then(() => {
        resolve();
      });
    });
  },
  addTags ({ commit }, { context, variableIds, tagIds }) {
    return new Promise((resolve) => {
      tagApi.addTags(context, variableIds, tagIds).then(() => {
        resolve();
      });
    });
  }
};

const merge = (from, to) => {
  for (let i = 0; i < to.length; i++) {
    const node = findNodeById(from, to[i].data.id);
    to[i].state = {
      expanded: (node && node.states) ? node.states.expanded : undefined,
      dropable: (node && node.states) ? node.states.dropable : true,
      draggable: (node && node.states) ? node.states.draggable : true
    };

    if (node) {
      merge(node.children, to[i].children);
    }
  }
  return to;
};

const findNodeById = (nodes, id) => {
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].data.id === id) {
      return nodes[i];
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/tag/index.js